<template>
	<div class="flex items-center">
		<span :class="`mr-02 whitespace-nowrap ${isOpportunity ? 'text-strong' : isLengthNotOptimal ? 'text-message-warning' : 'text-message-success'}`"
			><Duration :duration="duration" short
		/></span>

		<span class="whitespace-nowrap">{{ rangeDescription }}</span>

		<span v-if="isLengthNotOptimal" class="ml-02 whitespace-nowrap text-ink-100"
			>(<Duration :duration="recommendedDuration" short /> recommended)</span
		>
	</div>

	<div v-if="event.discount_depth" class="flex items-center">
		<span :class="`mr-02 whitespace-nowrap ${isDepthNotOptimal ? 'text-message-warning' : 'text-message-success'}`"
			>{{ event.discount_depth }}%</span
		>
		<span class="whitespace-nowrap">Discount depth</span>

		<span v-if="isDepthNotOptimal" class="ml-02 whitespace-nowrap text-ink-100">({{ event.recommended_discount_depth }}% recommended)</span>
	</div>

	<div v-if="event.notes?.length" class="notes mt-04 flex flex-col gap-02">
		<EventNote :note="event.notes[0]" />

		<div v-if="event.notes.length > 1" class="font-caption ml-03 mt-02 text-ink-60">
			{{ t('eventNotes.hasMore', { count: event.notes.length - 1 }) }}
		</div>
	</div>

	<div>
		<slot name="footer" />
	</div>
</template>

<script setup lang="ts">
import { useTranslation } from '@bluebrick/saas-ui'
import { toRefs } from 'vue'
import Duration from '@/features/eventDetails/components/Duration.vue'
import EventNote from '@/features/eventDetails/components/EventNote.vue'
import { useEvent } from '@/features/events/useEvent'
import { type EventData } from '@/types'

const props = defineProps<{ event: EventData }>()
const { t } = useTranslation()

const { event } = toRefs(props)

const { isLengthNotOptimal, duration, rangeDescription, recommendedDuration, isDepthNotOptimal, isOpportunity } = useEvent(event)
</script>
